import { Grid, LayoutContainer } from '@petsmart-ui/sparky';
import cn from 'classnames';

import { ContentfulClick } from '@libs/analytics';
import { cutText } from '@libs/contentful/utils';

import HeroCard from './HeroCard/HeroCard';
import type { HeroCardTile4upProps } from './types';
import './HeroCard/HeroCard.scss';

export default function HeroCardTile4up({ leftBlock, rightBlock, rightBlockTextColor }: HeroCardTile4upProps) {
    if (leftBlock.length !== 1 || rightBlock.length !== 4) {
        return null;
    }

    return (
        <LayoutContainer className="storytelling-hero-card-4-up">
            <Grid variant="2up" data-testid="storytelling-card-hero-4up">
                <Grid.Item>
                    {leftBlock.map((card, index) => (
                        <ContentfulClick
                            component={HeroCard}
                            key={card.sysId}
                            {...card}
                            eventData={{
                                position: index + 1,
                                linkText: cn(
                                    card.preheader && cutText(card.preheader, 15),
                                    card.header,
                                    card.bodyText && cutText(card.bodyText, 70)
                                ),
                                linkUrl: card.link?.webUrl ?? '',
                                promoTitle: card.header,
                                promoVariant: `storytelling card up - Hero Card Tile 4up - ${card.variant}`,
                                promoDesc: card.internalTitle,
                                promoType: 'storytelling-card-up__hero',
                            }}
                        />
                    ))}
                </Grid.Item>
                <Grid.Item>
                    <Grid variant="side-by-side" gridItemWrap="center">
                        {rightBlock.map((card, index) => (
                            <Grid.Item key={card.sysId}>
                                <ContentfulClick
                                    component={HeroCard}
                                    {...card}
                                    textColor={rightBlockTextColor}
                                    eventData={{
                                        position: index + 1,
                                        linkText: cn(
                                            card.preheader && cutText(card.preheader, 15),
                                            card.header,
                                            card.bodyText && cutText(card.bodyText, 70)
                                        ),
                                        linkUrl: card.link?.webUrl ?? '',
                                        promoTitle: leftBlock[0].header,
                                        promoVariant: `storytelling card up - Hero Card Tile 4up - ${card.variant}`,
                                        promoDesc: card.internalTitle,
                                        promoType: 'storytelling-card-up__hero-tile',
                                    }}
                                />
                            </Grid.Item>
                        ))}
                    </Grid>
                </Grid.Item>
            </Grid>
        </LayoutContainer>
    );
}
